<template>
  <div id="TimeTunnel"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool";

const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])
const {rgbToHsb} = colorTool()


const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')

let currentColorArr = reactive({arr: []})
let animateSpeed = ref(1) //1-10
let high = ref(null)
let low = ref(null)
let dynamicMode = ref(false)
let nowTemperature = ref(null)
let drawPot = ref(0)
let allRedMode = ref(false)


const handleGetAnimateHSB = (high, low, now = 10) => {
  let lowHeightRange = Math.ceil((high - low) / 10) // 將高低差 分為 10個單位, 1單位

  let range = Math.trunc((now - low) / lowHeightRange)

  if (range <= 0) animateSpeed.value = 20
  else if (range >= 10 ) animateSpeed.value = 36
  else animateSpeed.value = 20 + Math.floor(1.5 * range)
}


const timeTunnelAnimate = (sketch) => {
  let xmotion = 0;
  let ymotion = 0;
  let radius = 40; // 中間大小
    let cw = defaultWidth.value
    let ch = defaultHeight.value
  let mmx
  let count

    sketch.setup = () => {
        sketch.createCanvas(cw, ch)
        sketch.frameRate(30)
        sketch.colorMode(sketch.HSB, 360, 100,100, 255);
        sketch.noStroke()
        sketch.strokeWeight(0.5)
        sketch.noiseDetail(4, 0.2)
        sketch.background(0)
      mmx = sketch.round(240 / cw * 6)
      count = 3 + mmx

    }
    sketch.draw = () => {
      drawPot.value++
      sketch.noStroke()
      sketch.fill(0,0,0,16)
      sketch.rect(0,0, sketch.width, sketch.height)
      let j = 0
      let i = 0
      for (j = 0; j < 1; j += 0.002) {
        let jnorm_j = sketch.abs(0.5 - j) * 2; //絕對值
        for (i = 0; i < count; i++) {
          let norm_i = i / count; //第幾條線？
          let unit_i = 1 / count;
          let inorm_i = sketch.abs(0.5 - norm_i) * 4;
          let n = (0.5 - sketch.noise(inorm_i + xmotion, jnorm_j + ymotion)) * 2;
          let cx = radius * sketch.sin(norm_i * sketch.PI * 2 + n * 2 + xmotion);
          let cy = radius * sketch.cos(norm_i * sketch.PI * 2 + n * 2 + ymotion);
          let cx2 = radius * sketch.sin((unit_i + norm_i) * sketch.PI * 2 + xmotion);
          let cy2 = radius * sketch.cos((unit_i + norm_i) * sketch.PI * 2 + ymotion);
          let x = cw / 2 + sketch.sin(xmotion / 2) * 8;
          let y = ch / 2 + sketch.cos(ymotion / 2) * 8;
          const hColor = currentColorArr.arr[0] % 360
          const sColor = currentColorArr.arr[1]
          const vColor = currentColorArr.arr[2]
          const op = sketch.abs(255 * n * 3)
          const hColorMode = allRedMode.value ? 0 : (hColor + inorm_i * 90) + sketch.abs(sketch.sin(xmotion + n * sketch.PI * 2 + norm_i * sketch.PI * 2) * 90)

          sketch.stroke(
              hColorMode,
              sColor,
              vColor,
              op
          )
          sketch.line(
              x + cx / j,
              y + cy / j,
              x + cx2 / j,
              y + cy2 / j
          )
          sketch.noStroke();
        }
      }
      // 控制速度
      xmotion += (0.0015 * animateSpeed.value);
      ymotion += (0.0015 * animateSpeed.value);
    }

    sketch.windowResized = function () {
        cw = document.documentElement.clientWidth
		    ch = document.documentElement.clientHeight
		    sketch.resizeCanvas(cw, ch, true);
	}
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 7200) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(timeTunnelAnimate, 'TimeTunnel')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(timeTunnelAnimate, 'TimeTunnel')
  }
})

watch(dynamicMode, (n,o) => {
  if (n !== o) {
    initAnimate()
    canvasWrap.value = new p5(timeTunnelAnimate, 'TimeTunnel')
  }
})

watchEffect(() => {
  const {
    Effect,
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    Colors,
    HighColors,
  } = effectThemeData

  dynamicMode.value = IsDynamicMode
  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  if (IsDynamicMode.toString() === 'false') {
    // RGBToHSB
    currentColorArr.arr = rgbToHsb(Colors[0])
    allRedMode.value =  currentColorArr.arr[0] <= 0
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  }
  if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    // RGBToHSB
    currentColorArr.arr = rgbToHsb(HighColors[0])
    allRedMode.value =  currentColorArr.arr[0] <= 0
    handleGetAnimateHSB(high.value, low.value, nowTemperature.value)
  }

})

onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(timeTunnelAnimate, 'TimeTunnel')
})

onUnmounted(() => {
  currentColorArr.arr = []
  animateSpeed.value = 1
  high.value = null
  low.value = null
  dynamicMode.value = false
  nowTemperature.value = null
  drawPot.value = 0
  allRedMode.value = false
  initAnimate()
})
</script>
